import React, { useCallback, useMemo, useRef, useState } from 'react';
import styles from './s.module.less';
import LeftPanel from './components/LeftPanel';
import RightPanel from './components/RightPanel';
import WebPreview from './components/RightPanel/Preview';
import useGetClosedFunnelDetail from 'hooks/closedFunnel/useGetClosedFunnelDetail';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Spin } from 'antd';
import useGetSettingData from 'hooks/useGetSettingData';
import { EnumFields } from 'types/enumerationData';
import PracticeFrontPreviewStore from 'store/PracticeFrontPreview';
import { PATH } from 'constants/path';

const ClosedFunnelDetail = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [data, loading, refresh] = useGetClosedFunnelDetail(id!);
    const [conditionsSetting] = useGetSettingData(EnumFields.HELLO_KLARITY_CONDITION);
    const [statesSetting] = useGetSettingData(EnumFields.STATE);
    const [currentTab, setCurrentTab] = useState<string>('info');
    const [secondTab, setSecondTab] = useState<string>('questions');
    const [, set] = PracticeFrontPreviewStore.useStore();
    const typeOptions = useRef([
        {
            label: 'Condition',
            value: 'CONDITION',
        },
    ]);

    const conditionOptions: { label: string; value: string }[] = useMemo(() => {
        return conditionsSetting ? conditionsSetting.map((item: any) => ({
            label: item.content,
            value: item.content,
        })) : [];
    }, [conditionsSetting]);

    const statesOptions: { label: string; value: string }[] = useMemo(() => {
        return statesSetting ? statesSetting.map((item: any) => ({
            label: item.content,
            value: item.dictKey,
        })) : [];
    }, [statesSetting]);

    const handleSuccess = useCallback(() => {
        refresh(id!);
        set('flag', {});
    }, [refresh, id]);

    const handleExit = useCallback(() => {
        navigate(`${PATH.OPERATION}/${PATH.CLOSED_FUNNEL}`);
    }, [navigate]);

    return (
        <div className={styles.wrap}>
            <Spin spinning={loading}>
                <div className={styles.detailPage}>

                    <LeftPanel
                        info={data}
                        conditionOptions={conditionOptions}
                        statesOptions={statesOptions}
                        typeOptions={typeOptions.current}
                        currentTab={currentTab}
                        secondTab={secondTab}
                        setSecondTab={setSecondTab}
                        setCurrentTab={setCurrentTab}
                        onSuccess={handleSuccess}
                    />
                    <RightPanel>
                        <WebPreview showStaticImage={currentTab === 'blocks' && secondTab === 'matching'} link={data?.basicInfo?.link} />
                    </RightPanel>
                </div>
            </Spin>
            <div className={styles.footer}>
                <Button onClick={handleExit}>Exit</Button>
            </div>
        </div>
    );
};

export default ClosedFunnelDetail;
